import { getLevel } from "./utils/is.after";

export const getCurrentPathInfo=()=>{
  let urls =location.pathname.split("/");
  return getLevel(urls[urls.length-1]);
};
export const enabledNextLevel=(level)=>{
  const pathInfo=getCurrentPathInfo();
  let levels = getPathLevel();
  levels[`LEVEL-${pathInfo.level}`] ={ isNext: true };
  sessionStorage.setItem("PAGELEVEL", JSON.stringify(levels));
};
export const clearAllLevel=()=>{
  sessionStorage.clear("PAGELEVEL");
};
export const clearAllNextLevel=(level)=>{
  let levels = getPathLevel();
  if(Object.keys(levels).length > 0){
    for(let index=level;index<6;index++){
      let currentLevel= `LEVEL-${index}`;
      delete levels[currentLevel];
    }
    sessionStorage.setItem("PAGELEVEL", JSON.stringify(levels));
  }
};
export const getPathLevel=()=>{
  let levels = JSON.parse(sessionStorage.getItem("PAGELEVEL"));
  if(levels === null || levels === undefined){
    levels ={};
  }
  return levels;
};
export const sequenceHandledListener=(currentPathInfo)=>{
  let lastLevel = getPathLevel();
  let currentLevel = currentPathInfo.level;
  lastLevel=lastLevel[`LEVEL-${currentLevel-1}`];
  if(currentLevel !== 1 && !(lastLevel && ("isNext" in lastLevel) &&lastLevel.isNext)){
    window.location.assign('/clapply/cl/CLError.action');
  }
};
